

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 * @param {boolean} isGrey - If true, then it will set to use the light grey version of the spinner
 *                            Pass body to block the whole page.
 */
function addSpinner($target, isGrey) {
    const spinnerUrl = isGrey ? document.querySelector(".spinner-url.spin-grey").getAttribute("data-url") : document.querySelector(".spinner-url").getAttribute("data-url");
    const spinnerAlt = document.querySelector(".js-spinner-alt").getAttribute("data-spinner-alt");
    const veil = `
        <div class="veil">
            <div class="underlay ${isGrey ? "transparent" : ""}"></div>
            <div class="spinner">
                <img src="${spinnerUrl}" class="load-logo" alt="${spinnerAlt}" />
            </div>
        </div>
    `;
    let $veil = $(veil);

    if ($target.get(0).tagName === "IMG") {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css("position") === "static") {
            $target.parent().css("position", "relative");
        }
    } else {
        $target.append($veil);
        if ($target.css("position") === "static") {
            $target.parent().css("position", "relative");
            $target.parent().addClass("veiled");
        }
        if ($target.get(0).tagName === "BODY") {
            $veil.find(".spinner").css("position", "fixed");
        }
    }
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    if ($veil.parent().hasClass("veiled")) {
        $veil.parent().css("position", "");
        $veil.parent().removeClass("veiled");
    }
    $veil.off("click");
    $veil.remove();
}

// element level spinner:
$.fn.spinner = function () {
    var $element = $(this);
    var Fn = function () {
        this.start = function (isGrey) {
            if ($element.length) {
                addSpinner($element, isGrey);
            }
        };
        this.stop = function () {
            if ($element.length) {
                var $veil = $(".veil");
                removeSpinner($veil);
            }
        };
    };
    return new Fn();
};

// page-level spinner:
$.spinner = function () {
    var Fn = function () {
        this.start = function () {
            addSpinner($("body"));
        };
        this.stop = function () {
            removeSpinner($(".veil"));
        };
    };
    return new Fn();
};
